var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_13105",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(-17 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 17, 337)",
    filter: "url(#Rect\\xE1ngulo_13105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13105-2",
    "data-name": "Rect\\xE1ngulo 13105",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(9 6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-12.824 -47.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7315",
    "data-name": "Trazado 7315",
    d: "M-2074.548,12738.982v-2.364s-4.109-.241-4.969-.752a3.222,3.222,0,0,1-1.854-2.417,16.5,16.5,0,0,1,.859-5.4,8.032,8.032,0,0,1,3.76-3.895,5.768,5.768,0,0,1,3.733-.188s.725.673.725.994v9.188h3.126v-12.6h-7.369a11.641,11.641,0,0,0-6.178,2.417c-2.444,2.176-2.686,4.083-2.686,4.083a37.83,37.83,0,0,0-1.208,5.211,9.679,9.679,0,0,0,.215,3.894,2.7,2.7,0,0,0,2.2,1.827Z",
    transform: "translate(2129.519 -12319.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7316",
    "data-name": "Trazado 7316",
    d: "M-2082.312,12738.982v-2.364s4.109-.241,4.969-.752a3.221,3.221,0,0,0,1.854-2.417,16.508,16.508,0,0,0-.859-5.4,8.033,8.033,0,0,0-3.76-3.895,5.768,5.768,0,0,0-3.733-.188s-.725.673-.725.994v9.188h-3.126v-12.6h7.37a11.64,11.64,0,0,1,6.177,2.417c2.444,2.176,2.686,4.083,2.686,4.083a37.766,37.766,0,0,1,1.208,5.211,9.675,9.675,0,0,1-.215,3.894,2.7,2.7,0,0,1-2.2,1.827Z",
    transform: "translate(2145.34 -12319.77)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.089dde7300271187e05f1d1b8be29485.svg";
export { ForwardRef as ReactComponent };